import jquery from 'jquery';

/**
 * Publishes jQuery as a global before anything that expects it loads.
 *
 * Semantic UI 2.4 is a set of jQuery plugins whose IIFEs close over the free
 * variable `jQuery`, and jquery-validation does the same. A bundler resolves
 * jQuery's UMD wrapper to a module export rather than a global, so without this
 * they find nothing. Import order in main.ts is what makes it work: ES modules
 * evaluate depth-first in import order, so this runs first.
 */
declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = jquery;
window.jQuery = jquery;

export default jquery;
